<!-- Start of Quick search common component -->
 @if(this.selectedTabIndex !== 2){
<app-quick-search [DefaultFilterArray]="DefaultFilterArray" [QuickSearchFilterArray]="quickFilterArray"
  (updateDefaultArray)="updateDefaultArray($event)" (clearQuickSearch)="clearQuickSearch($event)">
</app-quick-search>
 }
<!-- End of Quick search common component -->

<!-- Filter Code  -->
<div class="col-lg-12 nopadding">
  <app-filter-panel [GridColumns]="GridColumns" [DefaultFilterArray]="getFilterArray()"
    (FilterEvent)="FilterApplyFilterEvent($event)" [isDatefilterDropdown]="true" [isAddFilter]="selectedTabIndex !== 2">
  </app-filter-panel>
</div>


<!--Grid Code  -->
<div class="col-lg-12 nopadding">
  @if(isLoadingResults){
  <div class="example-loading-shade">
    <mat-spinner></mat-spinner>
  </div>
  }

<p-tabs class="transaction-tab" [value]="selectedTabIndex" (valueChange)="selectedTabIndex = $event">
    <p-tablist>
    <p-tab [value]="0">Summary</p-tab>
    <p-tab [value]="1">Details</p-tab>
    <p-tab [value]="2">606 - CAT Comparison</p-tab>
     </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="0">
         <!-- processed-transactions Summary Screen -->
          <app-odr-summary [defaultFilters] ="DefaultFilterArray"></app-odr-summary>
        <!-- End of processed-transactions Summary Screen -->
        </p-tabpanel>
        <p-tabpanel [value]="1">
          <!-- processed-transactions Detail Screen -->
           <app-processed-transactions [defaultFilters] ="DefaultFilterArray"></app-processed-transactions>
        <!-- End of processed-transactions Detail Screen -->
          </p-tabpanel>
          <p-tabpanel [value]="2">
          <!-- processed-transactions CAT comparison Screen -->
           <app-cat-comparison [defaultFilters] ="DefaultFilterArray"></app-cat-comparison>
        <!-- End of processed-transactions CAT comparison Screen -->
          </p-tabpanel>
        </p-tabpanels>
        </p-tabs>

  </div>